import React from 'react'
import styles from './EdofSection6.module.css';
const data = [
    "Provides statistically significant increase in depth of focus: +0.78 D vs control (p = 0.0002)*",
    "Intermediate Vision (66 cm): 1.5 line improvement",
    "2.2 lines in ≥60 years",
    "Near Vision (40 cm): 1.6 line improvement",
    "2.0 lines in ≥60 years",
    "Designed Without Discrete Multifocal Zones",
];
const EdofSection6 = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.LeftSection}>
                    <p>The lens extends functional focus while preserving distance vision through a design that works with the eye’s natural physiology.</p>
                </div>
                <div className={styles.RightSection}>
                    <img src='/Images/Defth-of-field_new.png' alt='Defth-of-field_new' loading="lazy" decoding="async" />
                </div>
            </div>
            <div className={styles.container2}>
                <div className={styles.LeftBox}>
                    {data.map((item, index) => (
                        <div key={index} className={styles.item}>
                            <img src="/svg/green_star.svg" alt="green_star" className={styles.icon} loading="lazy" decoding="async" />
                            <p>{item}</p>

                        </div>
                    ))}
                    <p className={styles.starP}>*Evaluated using negative lens–
                        induced DOF at 0.2 logMAR threshold.</p>

                </div>
                <div className={styles.RightBox}>
                    <p>The Deseyne Extended Depth of Focus (EDOF) Lightfield creates a condensed interfocal distance providing continuous improvement in visual performance across the near-intermediate focus continuum.</p>
                    <p>The spherical, single-vision lens responds to the natural changes that come with aging without adding multifocal complexity.</p>

                    <div className={styles.ImgBox}>
                        <img src='/Images/men_Driving.webp' alt='men_Driving' />
                    </div>
                </div>
            </div>
            <div className={styles.ImgBoxMobile}>
                <img src='/Images/men_Driving.webp' alt='men_Driving' />
            </div>
        </div>
    )

}

export default EdofSection6
